module.exports = "/packs/011-5e907fd66fa64358121103599f0f863c.jpg";